var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLinkIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.4316 12.3203H1.68V4.56868H5.82107L7.50107 2.88867H0.840002C0.383159 2.88867 0 3.25709 0 3.72867V13.1603C0 13.6171 0.368422 14.0003 0.840002 14.0003H10.2716C10.7284 14.0003 11.1116 13.6319 11.1116 13.1603V6.51394L9.4316 8.19395V12.3203Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.1605 0H8.87209C8.40051 0 8.03209 0.368422 8.03209 0.840002C8.03209 1.31158 8.40051 1.68 8.87209 1.68H11.1416L6.10156 6.72002C5.77735 7.04423 5.77735 7.57476 6.10156 7.89897C6.26366 8.06107 6.48472 8.14949 6.69103 8.14949C6.89735 8.14949 7.1184 8.06107 7.28051 7.89897L12.3205 2.85895V5.12843C12.3205 5.58528 12.6889 5.96844 13.1605 5.96844C13.6174 5.96844 14.0005 5.60001 14.0005 5.12843V0.840002C14.0005 0.368422 13.6321 0 13.1605 0Z"
}), "\u0192\n  ")));
export default SvgExternalLinkIcon;